/* eslint-disable no-shadow */

// Dev Panel feature flag overrides
// Only applies to current tab and clears on reload, not kept in local storage
// Merged over the Fusebox values into featureFlags flags
const state = {
  flags: {},
};

export const mutations = {
  setOverride(state, { slug, value }) {
    state.flags = {
      ...state.flags,
      [slug]: value,
    };
  },

  removeOverride(state, slug) {
    const flags = { ...state.flags };
    delete flags[slug];
    state.flags = flags;
  },

  clearOverrides(state) {
    state.flags = {};
  },
};

export const actions = {
  // Toggling back to the Fusebox value removes the override instead of storing a no-op
  toggleOverride({ commit, rootState }, { slug, value }) {
    const fuseboxValue = rootState.featureFlags.fuseboxFlags[slug] ?? false;

    if (value === fuseboxValue) {
      commit('removeOverride', slug);
    } else {
      commit('setOverride', { slug, value });
    }
  },

  clearOverrides({ commit }) {
    commit('clearOverrides');
  },
};

export const getters = {
  overrideCount: (state) => Object.keys(state.flags).length,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
